import { render, staticRenderFns } from "./PersonEditForm.vue?vue&type=template&id=0ad8ff4f&"
import script from "./PersonEditForm.vue?vue&type=script&lang=js&"
export * from "./PersonEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports